import { z } from "zod";
import { ticketTypeSchema } from "../../ticket/ticket-type.schema";

export const ticketTypesSchema = z.object({
	ticketTypes: z.array(ticketTypeSchema),
});

export type TicketTypesSchema = z.infer<typeof ticketTypesSchema>;
